module.exports = __webpack_public_path__ + "img/naotu_7.19cab514.png";